<template>
    <div>
        <v-container fluid pt-0 grid-list-xl>
            <section-tooltip title="Guest Registrations"></section-tooltip>
            <app-card customClasses="mb-30 inherit-overflow">
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" @click="$refs.grid.instance.exportToExcel(false)"
                        small absolute top right>
                        <v-icon dark>grid_on</v-icon>
                    </v-btn>
                    <span>Excel export</span>
                </v-tooltip>
                <v-layout row wrap align-center mb-3>
                    <v-flex xs12 sm4 md3>
                        <v-select
                            :items="filteredEvents"
                            v-model="selectedEventId"
                            item-text="eventName"
                            item-value="eventId"
                            label="Event"
                            clearable
                            @change="onEventChange"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <dx-data-grid
                    ref="grid"
                    :data-source="dataSource"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :row-alternation-enabled="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :headerFilter="{ visible: true }"
                    :height="'1600px'"
                >
                    <dx-export :enabled="true" :file-name="'GuestRegistrations'" />
                    <dx-paging :page-size="50" />
                    <dx-pager :show-page-size-selector="true" :allowed-page-sizes="[20, 50, 100]" :show-info="true" />
                    <dx-filter-row :visible="true" />

                    <dx-column data-field="event_id" caption="Event" :calculate-cell-value="getEventName" alignment="left" />
                    <dx-column data-field="day_of_attendance" caption="Day of Attendance" data-type="date" :format="'dd/MM/yyyy'" />
                    <dx-column data-field="first_name" caption="First Name" />
                    <dx-column data-field="last_name" caption="Last Name" />
                    <dx-column data-field="email" caption="Email" />
                    <dx-column data-field="selected_days" caption="Selected Days" />
                    <dx-column data-field="guest_type" caption="Guest Type" />
                </dx-data-grid>
            </app-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            selectedEventId: null,
            eventIdsWithData: [],
            dataSource: null
        }
    },
    computed: {
        ...mapGetters(['guestDetailEvents', 'user', 'season']),
        eventIdNameMap() {
            return this.guestDetailEvents.reduce(function (map, obj) {
                map[obj.eventId] = obj.eventName
                return map
            }, {})
        },
        filteredEvents() {
            return this.guestDetailEvents.filter(e => this.eventIdsWithData.includes(e.eventId))
        }
    },
    methods: {
        onEventChange() {
            this.loadData()
        },
        getEventName(rowData) {
            return this.eventIdNameMap[rowData.event_id] || rowData.event_id
        },
        async loadData() {
            const validEventIds = this.guestDetailEvents.map(e => e.eventId)
            if (!validEventIds.length) {
                this.dataSource = []
                return
            }
            const query = {}
            if (this.selectedEventId) {
                query.event_id = this.selectedEventId
            } else {
                query.event_id = { $in: validEventIds }
            }
            const result = await this.$store.dispatch('getGuestRegistrations', {
                skip: 0,
                take: 10000,
                query: query
            })
            this.dataSource = result.data
            this.eventIdsWithData = [...new Set(result.data.map(r => r.event_id))]
        }
    },
    async created() {
        await this.$store.dispatch('getGuestDetailsEvents', { companyId: this.user.company.id, seasonId: this.season })
        await this.loadData()
    }
}
</script>
